<template>
  <div class="ts-page">
    <div class="ts-page-header">
      <div class="ts-page-title">TeamSystem Bilanci</div>
      <div class="ts-page-subtitle">
        Caricamento file e gestione storico per <b>Anagrafica</b> e <b>Saldi</b>.
      </div>
    </div>

    <div v-if="loadingAny" class="ts-global-loader">
      <Loader />
    </div>

    <div v-if="!rowsModal.type" class="ts-tabs-wrap">
      <div class="ts-tabs-title">Seleziona un modulo</div>

      <div class="ts-tabs">
        <button
          class="p-button p-button-info ts-btn ts-tab"
          type="button"
          :disabled="loading.anagrafici"
          @click="
            rowsModal.type = 'anagrafici';
            rowsModal.open = false;
            rowsModal.q = '';
            rowsModal.page = 1;
            rowsModal.perPage = 25;
            rowsModal.sortField = 'id';
            rowsModal.sortOrder = 'desc';
            rowsModal.data = [];
            rowsModal.meta = { page: 1, per_page: 25, total: 0, last_page: 1 };
            loadRows();
          "
        >
          Anagrafica
        </button>

        <button
          class="p-button p-button-info ts-btn ts-tab"
          type="button"
          :disabled="loading.saldi"
          @click="
            rowsModal.type = 'saldi';
            rowsModal.open = false;
            rowsModal.q = '';
            rowsModal.page = 1;
            rowsModal.perPage = 25;
            rowsModal.sortField = 'id';
            rowsModal.sortOrder = 'desc';
            rowsModal.data = [];
            rowsModal.meta = { page: 1, per_page: 25, total: 0, last_page: 1 };
            loadRows();
          "
        >
          Saldi
        </button>
      </div>

      <div class="ts-tabs-hint">
        Dopo la selezione vedrai i record direttamente e potrai caricare/scaricare i file.
      </div>
    </div>

    <div v-else class="ts-panel">
      <div class="ts-panel-header">
        <div class="ts-panel-left">
          <div class="ts-panel-title">
            {{ rowsModal.type === "saldi" ? "Saldi" : "Anagrafica" }}
          </div>
          <div class="ts-panel-subtitle">Tabella record + caricamento file + cronologia file.</div>
        </div>

        <div class="ts-panel-actions">
          <button
            class="p-button p-button-info ts-btn ts-btn-small ts-btn-ghost"
            type="button"
            @click="
              rowsModal.type = null;
              rowsModal.loading = false;
              rowsModal.q = '';
              rowsModal.page = 1;
              rowsModal.perPage = 25;
              rowsModal.sortField = 'id';
              rowsModal.sortOrder = 'desc';
              rowsModal.data = [];
              rowsModal.meta = { page: 1, per_page: 25, total: 0, last_page: 1 };
              document.body.style.overflow = '';
            "
          >
            Cambia tab
          </button>

          <button
            class="p-button p-button-info ts-btn ts-btn-small"
            type="button"
            :disabled="rowsModal.loading"
            @click="loadRows"
          >
            Ricarica record
          </button>

          <button
            class="p-button p-button-info ts-btn ts-btn-small"
            type="button"
            :disabled="loading[rowsModal.type]"
            @click="refresh(rowsModal.type)"
          >
            Ricarica file
          </button>
        </div>
      </div>

      <div class="ts-card ts-card-tight">
        <div class="ts-card-header ts-card-header-compact">
          <div>
            <div class="ts-card-title">Record</div>
            <div class="ts-card-desc">Ricerca, ordinamento e paginazione (server-side).</div>
          </div>

          <div class="ts-card-actions ts-card-actions-wide">
            <input
              class="ts-search-input"
              type="text"
              v-model="rowsModal.q"
              placeholder="Cerca..."
              @keydown.enter.prevent="applySearch"
              :disabled="rowsModal.loading"
            />

            <button
              class="p-button p-button-info ts-btn ts-btn-small"
              type="button"
              @click="applySearch"
              :disabled="rowsModal.loading"
            >
              Cerca
            </button>
          </div>
        </div>

        <div class="ts-card-body ts-card-body-nopad">
          <div v-if="rowsModal.loading" class="ts-section-loader">
            <Loader />
          </div>

          <div class="ts-table-wrap ts-table-wrap-noradius">
            <table class="ts-table">
              <thead>
                <tr>
                  <th v-for="c in rowsColumns" :key="c.field" @click="onSort(c)" class="ts-sort-th">
                    <span>{{ c.label }}</span>
                    <span v-if="rowsModal.sortField === c.field" class="ts-sort-ind">
                      {{ rowsModal.sortOrder === "asc" ? "▲" : "▼" }}
                    </span>
                  </th>
                </tr>
              </thead>

              <tbody>
                <tr v-if="rowsModal.data.length === 0 && !rowsModal.loading">
                  <td class="ts-empty" :colspan="rowsColumns.length">Nessun record trovato.</td>
                </tr>

                <tr v-for="r in rowsModal.data" :key="rowsRowKey(r)">
                  <td v-for="c in rowsColumns" :key="c.field" class="ts-cell">
                    {{ formatCell(r, c.field) }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="ts-pager-bar">
            <div class="ts-pager-left">
              <span class="ts-pager-text">
                Totale: <b>{{ rowsModal.meta.total }}</b>
                • Pagina <b>{{ rowsModal.meta.page }}</b> / <b>{{ rowsModal.meta.last_page }}</b>
              </span>
            </div>

            <div class="ts-pager">
              <select
                class="ts-perpage"
                v-model.number="rowsModal.perPage"
                :disabled="rowsModal.loading"
                @change="goToPage(1)"
              >
                <option :value="10">10</option>
                <option :value="25">25</option>
                <option :value="50">50</option>
                <option :value="100">100</option>
                <option :value="200">200</option>
              </select>

              <button
                class="p-button p-button-info ts-btn ts-btn-small"
                type="button"
                @click="prevPage"
                :disabled="rowsModal.loading || rowsModal.meta.page <= 1"
              >
                Prev
              </button>

              <button
                class="p-button p-button-info ts-btn ts-btn-small"
                type="button"
                @click="nextPage"
                :disabled="rowsModal.loading || rowsModal.meta.page >= rowsModal.meta.last_page"
              >
                Next
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="ts-actions-card">
        <input
          class="ts-toggle-radio"
          type="radio"
          name="tsAction"
          id="tsActionUpload"
          checked
        />
        <input
          class="ts-toggle-radio"
          type="radio"
          name="tsAction"
          id="tsActionHistory"
        />

        <div class="ts-actions-header">
          <div>
            <div class="ts-card-title">File</div>
            <div class="ts-card-desc">Carica un file oppure storico download.</div>
          </div>

          <div class="ts-actions-buttons">
            <label class="p-button p-button-info ts-btn ts-btn-small ts-toggle-btn" for="tsActionUpload">
              Carica file
            </label>
            <label class="p-button p-button-info ts-btn ts-btn-small ts-toggle-btn" for="tsActionHistory">
              File caricati
            </label>
          </div>
        </div>

        <div class="ts-actions-body ts-actions-upload">
          <div class="ts-upload-row">
            <div class="ts-file-wrap">
              <input
                :ref="rowsModal.type === 'saldi' ? 'fileSaldi' : 'fileAnagrafici'"
                class="ts-file-input"
                type="file"
                accept=".csv,.xlsx"
                @change="onPick(rowsModal.type)"
                :disabled="loading[rowsModal.type]"
              />

              <div class="ts-file-meta">
                <span v-if="picked[rowsModal.type].name" class="ts-file-name">
                  {{ picked[rowsModal.type].name }}
                </span>
                <span v-else class="ts-file-hint">Nessun file selezionato</span>
              </div>
            </div>

            <div class="ts-upload-actions">
              <button
                class="p-button p-button-info ts-btn"
                type="button"
                @click="upload(rowsModal.type)"
                :disabled="loading[rowsModal.type]"
              >
                Carica
              </button>

              <button
                class="p-button p-button-info ts-btn ts-btn-ghost"
                type="button"
                @click="resetPick(rowsModal.type)"
                :disabled="loading[rowsModal.type]"
              >
                Reset
              </button>
            </div>
          </div>
        </div>

        <div class="ts-actions-body ts-actions-history">
          <div v-if="loading[rowsModal.type]" class="ts-section-loader ts-loader-local">
            <Loader />
          </div>

          <div class="ts-table-wrap">
            <table class="ts-table">
              <thead>
                <tr>
                  <th style="width: 90px;">ID</th>
                  <th>Nome file</th>
                  <th style="width: 200px;">Caricato il</th>
                  <th style="width: 120px; text-align:right;">Righe</th>
                  <th style="width: 160px; text-align:right;">Azioni</th>
                </tr>
              </thead>

              <tbody>
                <tr v-if="history[rowsModal.type].length === 0">
                  <td class="ts-empty" colspan="5">Nessun file caricato.</td>
                </tr>

                <tr v-for="row in history[rowsModal.type]" :key="rowsModal.type + '-' + row.id">
                  <td>{{ row.id }}</td>
                  <td class="ts-mono">{{ row.file_name }}</td>
                  <td>{{ row.uploaded_at }}</td>
                  <td style="text-align:right;">{{ row.rows_count }}</td>
                  <td style="text-align:right;">
                    <button
                      class="p-button p-button-info ts-btn ts-btn-small"
                      type="button"
                      @click="download(rowsModal.type, row)"
                      :disabled="loading[rowsModal.type]"
                    >
                      Scarica
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import Loader from "@/components/Loader.vue";
import TeamsystemBilanciService from "@/services/teamsystem/teamsystem-service.js";
import { useToast } from "primevue/usetoast";

export default {
  name: "TeamsystemBilanciPage",
  components: { Loader },
  data() {
    return {
      service: null,
      toast: null,

      loading: {
        anagrafici: false,
        saldi: false,
      },

      picked: {
        anagrafici: { file: null, name: "" },
        saldi: { file: null, name: "" },
      },

      history: {
        anagrafici: [],
        saldi: [],
      },

      rowsModal: {
        open: false,
        type: null, // 'anagrafici' | 'saldi'
        loading: false,
        q: "",
        page: 1,
        perPage: 25,
        sortField: "id",
        sortOrder: "desc",
        data: [],
        meta: { page: 1, per_page: 25, total: 0, last_page: 1 },
      },
    };
  },
  computed: {
    loadingAny() {
      return !!(this.loading.anagrafici || this.loading.saldi);
    },

    rowsColumns() {
      if (this.rowsModal.type === "saldi") {
        return [
          { field: "id", label: "ID" },
          { field: "data_bilancio", label: "Data bilancio" },
          { field: "codice_anagrafica", label: "Cod. anagrafica" },
          { field: "ragione_sociale", label: "Ragione sociale" },
          { field: "codice", label: "Codice" },
          { field: "segno", label: "Segno" },
          { field: "saldo", label: "Saldo" },
          { field: "dare", label: "Dare" },
          { field: "avere", label: "Avere" },
          { field: "saldo_apertura", label: "Saldo apertura" },
          { field: "segno_apertura", label: "Segno apertura" },
        ];
      }

      return [
        { field: "id", label: "ID" },
        { field: "data_bilancio", label: "Data bilancio" },
        { field: "codice", label: "Codice" },
        { field: "conto", label: "Conto" },
        { field: "descrizione", label: "Descrizione" },
        { field: "rag_soc_ditta", label: "Rag. soc. ditta" },
        { field: "saldo_apertura", label: "Saldo apertura" },
        { field: "saldo", label: "Saldo" },
        { field: "dare", label: "Dare" },
        { field: "avere", label: "Avere" },
      ];
    },
  },
  created() {
    this.service = new TeamsystemBilanciService();
    this.toast = useToast();
  },
  mounted() {
    this.refresh("anagrafici");
    this.refresh("saldi");
  },
  beforeUnmount() {
    document.body.style.overflow = "";
  },
  methods: {
    toastSuccess(detail, summary = "Operazione completata") {
      this.toast?.add({ severity: "success", summary, detail, life: 3500 });
    },
    toastError(detail, summary = "Errore") {
      this.toast?.add({ severity: "error", summary, detail, life: 4500 });
    },
    getBackendMessage(err, fallback) {
      return err?.response?.data?.message || err?.response?.data?.error || err?.message || fallback;
    },

    // ================
    // Upload
    // ================
    onPick(type) {
      const refName = type === "saldi" ? "fileSaldi" : "fileAnagrafici";
      const input = this.$refs[refName];
      const file = input && input.files ? input.files[0] : null;

      this.picked[type].file = file || null;
      this.picked[type].name = file ? file.name : "";
    },

    resetPick(type) {
      const refName = type === "saldi" ? "fileSaldi" : "fileAnagrafici";
      const input = this.$refs[refName];
      if (input) input.value = "";

      this.picked[type].file = null;
      this.picked[type].name = "";
    },

    async upload(type) {
      const file = this.picked[type].file;

      if (!file) {
        this.toastError("Seleziona un file prima di caricare.");
        return;
      }

      const ext = String(file.name || "").split(".").pop().toLowerCase();
      if (!["csv", "xlsx"].includes(ext)) {
        this.toastError("Formato non supportato. Carica un file CSV o XLSX.");
        return;
      }

      this.loading[type] = true;
      try {
        await this.service.upload(type, file);

        this.toastSuccess(type === "saldi" ? "File Saldi caricato con successo." : "File Anagrafica caricato con successo.");

        this.resetPick(type);
        await this.refresh(type);

        if (this.rowsModal.type === type) {
          await this.loadRows();
        }
      } catch (err) {
        this.toastError(this.getBackendMessage(err, "Errore durante il caricamento del file."));
        throw err;
      } finally {
        this.loading[type] = false;
      }
    },

    // ================
    // History
    // ================
    async refresh(type) {
      this.loading[type] = true;
      try {
        const res = await this.service.getHistory(type);
        this.history[type] = Array.isArray(res?.data) ? res.data : [];
      } catch (err) {
        this.history[type] = [];
        this.toastError(this.getBackendMessage(err, "Errore durante il caricamento della cronologia."));
      } finally {
        this.loading[type] = false;
      }
    },

    async download(type, row) {
      this.loading[type] = true;
      try {
        await this.service.download(type, row);
        this.toastSuccess("Download avviato.");
      } catch (err) {
        this.toastError(this.getBackendMessage(err, "Errore durante il download del file."));
        throw err;
      } finally {
        this.loading[type] = false;
      }
    },

    rowsRowKey(r) {
      return `${this.rowsModal.type}-${r?.id ?? Math.random()}`;
    },

    formatCell(row, field) {
      const v = row ? row[field] : null;
      if (v === null || v === undefined) return "";

      if (this.isIsoDateOrDateTime(v)) {
        return this.formatDateIT(v);
      }

      if (this.isNumericLike(v)) {
        // Per evitare di formattare ID/codici
        if (field === "id" || field === "codice" || field === "conto" || field === "codice_anagrafica") {
          return v;
        }

        return this.formatNumberIT(v);
      }

      return v;
    },

    isIsoDateOrDateTime(v) {
      if (typeof v !== "string") return false;
      return /^\d{4}-\d{2}-\d{2}(?:\s+\d{2}:\d{2}:\d{2})?$/.test(v.trim());
    },

    formatDateIT(v) {
      const s = String(v).trim();
      const datePart = s.slice(0, 10); // yyyy-mm-dd
      const [y, m, d] = datePart.split("-").map((x) => parseInt(x, 10));

      if (!y || !m || !d) return v;

      // dd/mm/yyyy
      const dd = String(d).padStart(2, "0");
      const mm = String(m).padStart(2, "0");
      return `${dd}/${mm}/${y}`;
    },

    isNumericLike(v) {
      if (typeof v === "number") return Number.isFinite(v);

      if (typeof v !== "string") return false;

      const s = v.trim();
      if (s === "") return false;

      // accetto: 1234 | 1234.56 | 1.234,56 | 1,234.56 | -123 | ecc.
      const cleaned = s
        .replace(/\s+/g, "")
        .replace(/[€]/g, "")
        .replace(/\u00A0/g, "");

      return /^-?\d{1,3}([.,]\d{3})*([.,]\d+)?$/.test(cleaned) || /^-?\d+([.,]\d+)?$/.test(cleaned);
    },

    parseNumericToNumber(v) {
      if (typeof v === "number") return v;

      let s = String(v).trim();
      s = s.replace(/\s+/g, "").replace(/[€]/g, "").replace(/\u00A0/g, "");

      // Se ci sono sia . che , -> decimale è l'ultimo separatore
      const hasDot = s.includes(".");
      const hasComma = s.includes(",");

      if (hasDot && hasComma) {
        const lastDot = s.lastIndexOf(".");
        const lastComma = s.lastIndexOf(",");
        const decimalSep = lastComma > lastDot ? "," : ".";

        if (decimalSep === ",") {
          // migliaia: .  decimali: ,
          s = s.replace(/\./g, "");
          s = s.replace(/,/g, ".");
        } else {
          // migliaia: ,  decimali: .
          s = s.replace(/,/g, "");
        }
      } else if (hasComma && !hasDot) {
        // 1234,56 -> 1234.56
        s = s.replace(/,/g, ".");
      } else {
        // solo punto o nessun separatore: ok
      }

      const n = Number(s);
      return Number.isFinite(n) ? n : null;
    },

    formatNumberIT(v) {
      const n = this.parseNumericToNumber(v);
      if (n === null) return v;

      return new Intl.NumberFormat("it-IT", {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
      }).format(n);
    },


    async openRows(type) {
      this.rowsModal.open = true;
      this.rowsModal.type = type;
      this.rowsModal.q = "";
      this.rowsModal.page = 1;
      this.rowsModal.perPage = 25;
      this.rowsModal.sortField = "id";
      this.rowsModal.sortOrder = "desc";
      this.rowsModal.data = [];
      this.rowsModal.meta = { page: 1, per_page: 25, total: 0, last_page: 1 };

      document.body.style.overflow = "hidden";

      await this.loadRows();
    },

    closeRows() {
      this.rowsModal.open = false;
      this.rowsModal.type = null;
      this.rowsModal.loading = false;
      this.rowsModal.data = [];
      document.body.style.overflow = "";
    },

    async loadRows() {
      if (!this.rowsModal.type) return;

      this.rowsModal.loading = true;
      try {
        const res = await this.service.getRows(this.rowsModal.type, {
          page: this.rowsModal.page,
          per_page: this.rowsModal.perPage,
          sort_field: this.rowsModal.sortField,
          sort_order: this.rowsModal.sortOrder,
          q: this.rowsModal.q || undefined,
        });

        this.rowsModal.data = Array.isArray(res?.data) ? res.data : [];
        this.rowsModal.meta = res?.meta || { page: this.rowsModal.page, per_page: this.rowsModal.perPage, total: 0, last_page: 1 };
      } catch (err) {
        this.rowsModal.data = [];
        this.rowsModal.meta = { page: 1, per_page: this.rowsModal.perPage, total: 0, last_page: 1 };
        this.toastError(this.getBackendMessage(err, "Errore durante il caricamento dei record."));
      } finally {
        this.rowsModal.loading = false;
      }
    },

    applySearch() {
      this.goToPage(1);
    },

    onSort(col) {
      if (!col?.field) return;

      if (this.rowsModal.sortField === col.field) {
        this.rowsModal.sortOrder = this.rowsModal.sortOrder === "asc" ? "desc" : "asc";
      } else {
        this.rowsModal.sortField = col.field;
        this.rowsModal.sortOrder = "asc";
      }

      this.goToPage(1);
    },

    async goToPage(page) {
      this.rowsModal.page = Math.max(1, page);
      await this.loadRows();
    },

    async prevPage() {
      if (this.rowsModal.meta.page <= 1) return;
      await this.goToPage(this.rowsModal.meta.page - 1);
    },

    async nextPage() {
      if (this.rowsModal.meta.page >= this.rowsModal.meta.last_page) return;
      await this.goToPage(this.rowsModal.meta.page + 1);
    },
  },
};
</script>

<style scoped>
.ts-page { padding: 18px !important; }
.ts-page-header { margin-bottom: 14px !important; }
.ts-page-title { font-size: 22px !important; font-weight: 800 !important; margin: 0 !important; }
.ts-page-subtitle { margin-top: 6px !important; font-size: 13px !important; opacity: 0.9 !important; }

.ts-btn { border-radius: 10px !important; }
.ts-btn-small { padding: 0.45rem 0.75rem !important; font-size: 0.85rem !important; }
.ts-btn-ghost { background: transparent !important; color: #0b66a7 !important; border: 1px solid rgba(6, 141, 224, 0.55) !important; }

.ts-tabs-wrap {
  background: #ffffff !important;
  border: 2px solid rgba(17, 24, 39, 0.18) !important;
  border-radius: 12px !important;
  padding: 16px !important;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.10) !important;
}

.ts-tabs-title { font-weight: 900 !important; font-size: 14px !important; margin-bottom: 10px !important; }
.ts-tabs { display: flex !important; gap: 10px !important; flex-wrap: wrap !important; }
.ts-tab { padding: 0.65rem 1rem !important; font-weight: 800 !important; }
.ts-tabs-hint { margin-top: 10px !important; font-size: 12px !important; opacity: 0.85 !important; }

.ts-panel {
  display: grid !important;
  gap: 14px !important;
}

.ts-panel-header {
  display: flex !important;
  justify-content: space-between !important;
  align-items: center !important;
  gap: 12px !important;
  background: #ffffff !important;
  border: 2px solid rgba(17, 24, 39, 0.18) !important;
  border-radius: 12px !important;
  padding: 14px !important;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.10) !important;
}

.ts-panel-left { min-width: 0 !important; }
.ts-panel-title { font-size: 16px !important; font-weight: 900 !important; }
.ts-panel-subtitle { margin-top: 4px !important; font-size: 12px !important; opacity: 0.85 !important; }

.ts-panel-actions { display: flex !important; gap: 8px !important; flex-wrap: wrap !important; align-items: center !important; }

.ts-card {
  position: relative !important;
  background: #ffffff !important;
  border: 2px solid rgba(17, 24, 39, 0.18) !important;
  border-radius: 12px !important;
  overflow: hidden !important;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.10) !important;
}

.ts-card-tight { border-radius: 12px !important; }
.ts-card-header {
  display: flex !important;
  justify-content: space-between !important;
  align-items: center !important;
  padding: 14px !important;
  border-bottom: 2px solid rgba(17, 24, 39, 0.12) !important;
  background: rgba(6, 141, 224, 0.10) !important;
}

.ts-card-header-compact { padding: 12px 14px !important; }

.ts-card-actions { display: flex !important; gap: 8px !important; align-items: center !important; }
.ts-card-actions-wide { flex-wrap: wrap !important; justify-content: flex-end !important; }

.ts-card-title { font-size: 16px !important; font-weight: 800 !important; }
.ts-card-desc { margin-top: 4px !important; font-size: 12px !important; opacity: 0.85 !important; }

.ts-card-body { padding: 14px !important; }
.ts-card-body-nopad { padding: 0 !important; }

.ts-table-wrap {
  overflow: auto !important;
  border-radius: 10px !important;
  border: 2px solid rgba(17, 24, 39, 0.16) !important;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.06) !important;
}
.ts-table-wrap-noradius { border-radius: 0 !important; }

.ts-table { width: 100% !important; border-collapse: collapse !important; font-size: 13px !important; background: #fff !important; }
.ts-table thead th {
  background: #068de0 !important;
  color: #fff !important;
  font-weight: 800 !important;
  font-size: 12px !important;
  padding: 10px !important;
  text-transform: uppercase !important;
  letter-spacing: 0.02em !important;
  border-right: 1px solid rgba(255, 255, 255, 0.25) !important;
  user-select: none !important;
}
.ts-table thead th:last-child { border-right: none !important; }
.ts-table td { padding: 10px !important; border-bottom: 1px solid rgba(17, 24, 39, 0.14) !important; }
.ts-table tbody tr:hover td { background: rgba(6, 141, 224, 0.07) !important; }
.ts-empty { text-align: center !important; padding: 16px !important; opacity: 0.85 !important; }
.ts-mono { font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace !important; }

.ts-sort-th { cursor: pointer !important; }
.ts-sort-ind { margin-left: 8px !important; font-weight: 900 !important; }

.ts-search-input {
  height: 34px !important;
  padding: 0 10px !important;
  border-radius: 10px !important;
  border: 1px solid rgba(17, 24, 39, 0.22) !important;
  min-width: 240px !important;
  background: #fff !important;
}

.ts-pager-bar {
  display: flex !important;
  justify-content: space-between !important;
  align-items: center !important;
  gap: 10px !important;
  padding: 12px 14px !important;
  border-top: 1px solid rgba(17, 24, 39, 0.12) !important;
  background: #fff !important;
}

.ts-pager { display: flex !important; gap: 8px !important; align-items: center !important; }
.ts-pager-left { display: flex !important; align-items: center !important; }
.ts-pager-text { font-size: 13px !important; opacity: 0.9 !important; }

.ts-perpage {
  height: 34px !important;
  border-radius: 10px !important;
  border: 1px solid rgba(17, 24, 39, 0.22) !important;
  padding: 0 8px !important;
  background: #fff !important;
}

/* =========================
   ACTIONS CARD (UPLOAD/HISTORY)
   ========================= */
.ts-actions-card {
  position: relative !important;
  background: #ffffff !important;
  border: 2px solid rgba(17, 24, 39, 0.18) !important;
  border-radius: 12px !important;
  overflow: hidden !important;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.10) !important;
}

.ts-actions-header {
  display: flex !important;
  justify-content: space-between !important;
  align-items: center !important;
  gap: 12px !important;
  padding: 12px 14px !important;
  border-bottom: 2px solid rgba(17, 24, 39, 0.12) !important;
  background: rgba(6, 141, 224, 0.10) !important;
}

.ts-actions-buttons { display: flex !important; gap: 8px !important; align-items: center !important; flex-wrap: wrap !important; }

.ts-toggle-radio {
  position: absolute !important;
  opacity: 0 !important;
  pointer-events: none !important;
}

.ts-actions-body { padding: 14px !important; position: relative !important; }

.ts-toggle-btn {
  cursor: pointer !important;
  user-select: none !important;
}

/* Toggle logic */
#tsActionUpload:checked ~ .ts-actions-header .ts-toggle-btn[for="tsActionUpload"] { filter: brightness(0.95) !important; }
#tsActionHistory:checked ~ .ts-actions-header .ts-toggle-btn[for="tsActionHistory"] { filter: brightness(0.95) !important; }

#tsActionUpload:checked ~ .ts-actions-upload { display: block !important; }
#tsActionUpload:checked ~ .ts-actions-history { display: none !important; }

#tsActionHistory:checked ~ .ts-actions-upload { display: none !important; }
#tsActionHistory:checked ~ .ts-actions-history { display: block !important; }

/* Upload block */
.ts-upload-row {
  display: flex !important;
  align-items: flex-end !important;
  gap: 12px !important;
  padding: 10px !important;
  border: 1px solid rgba(17, 24, 39, 0.12) !important;
  border-radius: 10px !important;
  background: rgba(17, 24, 39, 0.02) !important;
}

.ts-file-wrap { flex: 1 !important; min-width: 0 !important; }
.ts-file-input {
  width: 100% !important;
  padding: 6px !important;
  border: 1px solid rgba(17, 24, 39, 0.22) !important;
  border-radius: 8px !important;
  background: #fff !important;
}
.ts-file-meta { margin-top: 8px !important; min-height: 16px !important; font-size: 12px !important; }
.ts-file-name {
  word-break: break-all !important;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace !important;
  opacity: 0.95 !important;
}
.ts-file-hint { opacity: 0.7 !important; }
.ts-upload-actions { display: flex !important; gap: 8px !important; align-items: center !important; }

.ts-loader-local { border-radius: 12px !important; }

/* LOADING */
.ts-global-loader {
  position: fixed !important;
  inset: 0 !important;
  background: rgba(255, 255, 255, 0.55) !important;
  display: grid !important;
  place-items: center !important;
  z-index: 999998 !important;
}

.ts-section-loader {
  position: absolute !important;
  inset: 0 !important;
  background: rgba(255, 255, 255, 0.75) !important;
  display: grid !important;
  place-items: center !important;
  z-index: 50 !important;
}

/* Responsive */
@media (max-width: 1100px) {
  .ts-upload-row { flex-direction: column !important; align-items: stretch !important; }
  .ts-upload-actions { justify-content: flex-end !important; }
  .ts-search-input { min-width: 180px !important; width: 100% !important; }
  .ts-panel-header { flex-direction: column !important; align-items: stretch !important; }
  .ts-panel-actions { justify-content: flex-end !important; }
  .ts-pager-bar { flex-direction: column !important; align-items: stretch !important; }
  .ts-pager { justify-content: flex-end !important; }
}
</style>